<template>
  <!-- 休日出勤報告作成 -->
  <div>
    <CCard>
      <CCardHeader>
        <h2>休日出勤報告作成</h2>
      </CCardHeader>
      <CCardBody>
        <span class="asterisk">*</span>
        <span style="margin-bottom: 1rem; display: inline-block">が付いている項目は必須入力項目です</span>

        <ValidationObserver ref="obs" v-slot="ObserverProps">
          <CRow>
            <div class="container">
              <table class="table table-borderless">
                
                <!-- 日付 -->
                <tr>
                  <th scope="row">日付<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name="日付" rules="required" v-slot="ProviderProps">
                          <CInput
                            type="date"
                            :min="date_min()"
                            :max="date_max()"
                            v-model="date"
                          />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 開始・終了予定時間 -->
                <tr>
                  <th scope="row">予定時間<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="6" lg="3">
                        <ValidationProvider name="開始予定時間" rules="required" v-slot="ProviderProps">
                          <label>開始予定時間<span class="asterisk">*</span></label>
                          <CInput type="time" v-model="start_time" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>

                      <CCol sm="6" lg="3">
                        <ValidationProvider name="終了予定時間" rules="required" v-slot="ProviderProps">
                          <label>終了予定時間<span class="asterisk">*</span></label>
                          <CInput type="time" v-model="end_time" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>

                <!-- 発生理由 -->
                <tr>
                  <th scope="row">発生理由<span class="asterisk">*</span></th>
                  <td>
                    <CRow>
                      <CCol sm="12" lg="6">
                        <ValidationProvider name="発生理由" rules="required" v-slot="ProviderProps">
                          <CInput v-model="reason" />
                          <p class="error">
                            <font color="red">{{ ProviderProps.errors[0] }}</font>
                          </p>
                        </ValidationProvider>
                      </CCol>
                    </CRow>
                  </td>
                </tr>
              </table>
              <CRow class="mt-3 align-items-center">
                <CCol class="text-start">
                  <button class="btn btn-secondary" @click="valueCheck">戻る</button>
                </CCol>
                <CCol class="text-center">
                  <save-button
                    :label="'報告'"
                    :loading="loading"
                    :disabled="ObserverProps.invalid"
                    @click="apply"
                    class="btn btn-primary"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <label class="mt-2">※ 別途申請処理無く上長が内容を確認します。（申請機能未実装）</label>
            </div>
          </CRow>
        </ValidationObserver>
      </CCardBody>
    </CCard>
  </div>
</template>


<script>
import ConstList from "./../../ConstList";
import axios from "axios";
import SaveButton from "./../../common/SaveButton";
export default {
  name: "RegisterInput",
  components: { SaveButton },
  data() {
    return {
      date: "",
      start_time: "",
      end_time: "",
      reason: "",
      holidayworksMasterList: "",
      // 二重サブミット対処フラグ
      submit_flg: false,
      loading: false,
    };
  },

  created() {
    this.holidayworksMasterList = ConstList.ROUTE_HOLIDAYWORKS_MASTERLIST;
  },

  computed: {
    DATE_MIN() {
      return ConstList.DATE_MIN;
    },
    DATE_MAX() {
      return ConstList.DATE_MAX;
    },
  },

  methods: {
    // 登録内容を送信
    apply: function () {
      //二重サブミット対策
      if (this.submit_flg) return;
      //フラグがfalseならば、フラグをtrueにしたうえでsubmit
      this.submit_flg = true;

        //二重サブミット後の処理
        if (confirm) {
          this.loading = true;
          const params = new URLSearchParams();
          params.append("date", this.date);
          params.append("start_time", this.start_time + ":00");
          params.append("end_time", this.end_time + ":00");
          params.append("reason", this.reason);
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/holidayWorkRegister",
              params
            )
            .then((response) => {
              this.submit_flg = false;
              if (response.data === ConstList.SUCCESS) {
                alert(ConstList.REGISTER_MESSAGE);
                this.$router.push({ name: "休日出勤報告" });
              } else {
                alert(ConstList.APPLY_ERROR);
              }
            })
            .catch((error) => {
              this.submit_flg = false;
              axios
              .get(
                `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
              )
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
            })
            .finally(() => {
              this.loading = false;
            });
        }
    },
    date_min() {
      return ConstList.DATE_MIN;
    },
    date_max() {
      return ConstList.DATE_MAX;
    },
    valueCheck: function () {
      if ((this.date != '') || 
        (this.start_time != '') || 
        (this.end_time != '') || 
        (this.reason != '')) {
        if (confirm(ConstList.TRANSITION)) {
          this.$router.push({
            name: ConstList.ROUTE_HOLIDAYWORKS_LIST,
          })
        }
      } else {
        this.$router.push({
          name: ConstList.ROUTE_HOLIDAYWORKS_LIST,
        })
      }
    },
  },
};
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}

.container {
  margin-left: 0%;
}
</style>
